<template>
  <section class="rb-slogan-wrapper">
    <div class="card-wrapper" v-for="(item, index) in stepList" :key="index">
      <Step :img="item.img" :text="item.label" />
      <div class="arrow-wrapper" v-if="index !== stepList.length - 1">
        <img :src="require('@/assets/images/icon/cnDepositBonus/arrow.png')" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
import Step from '../common/Step.vue';

export default {
  name: 'RedepositBonusSlogan',
  components: {
    Step
  },
  data() {
    return {
      stepList: [
        {
          label: this.$t('common.exchangeAmountPerDeposit'),
          img: require(`@/assets/images/icon/cnDepositBonus/single_deposit.png`)
        },
        {
          label: this.$t('common.receiveCredit'),
          img: require(`@/assets/images/icon/cnDepositBonus/get_credit.png`)
        },
        {
          label: this.$t('promotion.redepositBonus.tradeAmount'),
          img: require(`@/assets/images/icon/cnDepositBonus/trade.png`)
        },
        {
          label: this.$t('promotion.redepositBonus.specifiedLotAmountToWithdraw'),
          img: require(`@/assets/images/icon/cnDepositBonus/withdrawal.png`)
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.rb-slogan-wrapper {
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.arrow-wrapper {
  margin: 0 1em;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin: 0;
  }
}

.card-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
}
</style>
